<template>
    <v-container>
        <v-row>
            <v-col cols="12" md="6">
                <statistics-form @load="onLoadDocs" @reset="onReset"/>
            </v-col>
            <v-col cols="12" md="6" v-if="variables.wellness">
                <wellness :docs="docs" />
            </v-col>
            <v-col cols="12" md="6" v-if="variables.effort">
                <statistics-chart type="effort" :docs="docs" />
            </v-col>
            <v-col cols="12" md="6" v-if="variables.duration">
                <statistics-chart type="duration" :docs="docs" />
            </v-col>
            <v-col cols="12" md="6" v-if="variables.charge">
                <statistics-chart type="charge" :docs="docs" />
            </v-col>
            <v-col cols="12" md="6" v-if="variables.sessions">
                <statistics-chart type="sessions" :docs="docs" />
            </v-col>
            <v-col cols="12" md="6" v-if="variables.sets_strength">
                <statistics-chart type="sets_strength" :docs="docs" />
            </v-col>
            <v-col cols="12" md="6" v-if="variables.sets_speed">
                <statistics-chart type="sets_speed" :docs="docs" />
            </v-col>
            <v-col cols="12" md="6" v-if="variables.sets_resistance">
                <statistics-chart type="sets_resistance" :docs="docs" />
            </v-col>
            <v-col cols="12" md="6" v-if="variables.tonnage">
                <statistics-chart type="tonnage" :docs="docs" />
            </v-col>
            <v-col cols="12" md="6" v-if="variables.distance">
                <statistics-chart type="distance" :docs="docs" />
            </v-col>
            <v-col cols="12" md="6" v-if="variables.percentage">
                <statistics-chart type="percentage" :docs="docs" />
            </v-col>
            <v-col cols="12" md="6" v-if="variables.rpe">
                <statistics-chart type="rpe" :docs="docs" />
            </v-col>
            <v-col cols="12" md="6" v-if="variables.rir">
                <statistics-chart type="rir" :docs="docs" />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>

import StatisticsForm from "@/components/statistics/StatisticsForm";
import Wellness from "@/components/statistics/Wellness";
import StatisticsChart from "@/components/statistics/StatisticsChart";

export default {
    components: {StatisticsChart, Wellness, StatisticsForm},
    data() {
        return {
            variables: {},
            docs: [],
        }
    },
    methods: {
        onLoadDocs({variables, docs}) {
            const vm = this
            vm.variables = variables
            vm.docs = docs
        },
        onReset() {
            const vm = this
            vm.variables = {}
        }
    }
}
</script>

<style scoped>

</style>